import { render } from "./maternity_anc_profile.vue?vue&type=template&id=6ca43feb&scoped=true"
import script from "./maternity_anc_profile.vue?vue&type=script&lang=js"
export * from "./maternity_anc_profile.vue?vue&type=script&lang=js"

import "./maternity_anc_profile.vue?vue&type=style&index=0&id=6ca43feb&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca43feb"]])

export default __exports__